import {
    SET_ADVERTISER,
    CLEAR_ADVERTISER,
    GET_ADVERTISER_SUCCESS,
    GET_ADVERTISER_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function voluumAdvertiserReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_ADVERTISER:
            return {
                ...state,
                data,
            }
        case CLEAR_ADVERTISER:
            return {
                ...state,
                data: null,
            }
        case GET_ADVERTISER_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_ADVERTISER_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}